<script setup lang="ts">
/**
 * ModuleLayout - Standard frame for module views
 * Provides consistent structure within modules
 */
</script>

<template>
  <div class="module-layout">
    <!-- Module Header (optional) -->
    <div v-if="$slots.header" class="module-header">
      <slot name="header" />
    </div>

    <!-- Module Content -->
    <div class="module-content">
      <router-view v-slot="{ Component, route }">
        <Transition name="page" mode="out-in">
          <component :is="Component" :key="route.path" />
        </Transition>
      </router-view>
    </div>
  </div>
</template>

<style scoped>
.module-layout {
  animation: fade-in 0.2s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.module-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.module-content {
  /* Content takes full available space */
}

/* Page transitions */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
